module.exports = __webpack_public_path__ + "img/sky:-children-of-the-light.174de480.png";